export function participantThresholdMet({ threshold, attendees, responses }) {
  const totalThreshold = threshold || 0;
  const visibleAttendees = attendees || 0;
  const visibleYesResponses = responses || 0;

  return (
    totalThreshold <= visibleAttendees || totalThreshold <= visibleYesResponses
  );
}
